import { useEffect, useState } from "react";
import Select from "react-select";
import ManagerUserTable from "../../ManagerUserTable";
import Modal from "react-modal";
import { Icon } from "@iconify/react";
import { getUsers, sendInvitation } from "../../../../callApi/httpservice";
import { toast } from "react-toastify";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../srores";
import { ROLE } from "../../../../constants/admin.constants";
import SpinnerCustom from "../../../common/SpinnerCustom";
const take = 10;
function UserManager() {
  const { adminStore } = useStores();
  const [email, setEmail] = useState<string>("");
  const [role, setRole] = useState<any>(null);
  const [emailError, setEmailError] = useState<string>("");
  const [roleError, setRoleError] = useState<string>("");
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [items, setItems] = useState<any>(null);
  const [offset, setOffset] = useState<number>(0);
  const [skip, setSkip] = useState<number>(0);
  const [pageCount, setPageCount] = useState(0);
  const [isWaitingSend, setIsWaitingSend] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const optionsAdmin = [
    { value: "MANAGER", label: "Manager" },
    { value: "STAFF", label: "Staff" },
  ];
  const optionsManager = [{ value: "STAFF", label: "Staff" }];
  const theme = (theme: any) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#D4D4D4",
      primary: "#eed484",
    },
  });
  const styles = {
    control: (base: any, state: any) => ({
      ...base,
      background: "rgb(242 242 242 / var(--tw-bg-opacity))",
      border: 0,
      boxShadow: "none",
      borderRadius: 6,
      backgroundColor: state.isFocused ? "red" : "blue",
    }),
    option: (styles: any, state: any) => {
      return {
        ...styles,
        ":active": {
          backgroundColor: "#D4D4D4",
        },
      };
    },
  };
  const customStyles = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
    },
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const onSendClick = async () => {
    setIsWaitingSend(true);
    const checkValid = validate();
    if (checkValid) {
      try {
        const result = await sendInvitation({ email, role: role.value });
        if (result) {
          setModalIsOpen(true);
          setEmail("");
          setRole(null);
          handlePageClick({ selected: 0 });
          callApiGetUser(take, 0);
        }
      } catch (err) {
        console.log(err);
        toast.error("Email already exists");
      }
    }
    setIsWaitingSend(false);
  };
  const validate = () => {
    setEmailError("");
    setRoleError("");
    const msg: any = {};
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!email) {
      msg.email = "Email is required";
      setEmailError("Email is required");
    } else if (!regex.test(email)) {
      msg.email = "This is not a valid email format";
      setEmailError("This is not a valid email format");
    }
    if (!role) {
      msg.role = "Role is required";
      setRoleError("Role is required");
    }
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const callApiGetUser = async (take: number, skip: number) => {
    setIsFetching(true);
    const result: any = await getUsers({
      take,
      skip,
      sortDesc: true,
      sortBy: "createdAt",
    });
    if (result.status === 200) {
      setItems(result.data[0]);
      let count = result.data[1] as number;
      if (count % take === 0) {
        setPageCount(count / take);
      } else {
        setPageCount(Math.floor(count / take) + 1);
      }
    }
    setIsFetching(false);
  };
  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    setOffset(selectedPage);
    setSkip(selectedPage * take);
  };

  useEffect(() => {
    setItems(null);
    callApiGetUser(take, skip);
  }, [offset]);
  return (
    <>
      <div className="bg-white xsm:p-1 xsm:pt-3 md:pt-5 xl:pt-10  md:p-5 xl:p-10 shadow-lg rounded-lg xsm:text-[12px] xs:text-[14px]">
        <div className="font-bold xsm:text-[16px] xs:text-[18px] pb-5">
          Add member
        </div>
        <div className="border-t-2  xsm:w-[100%] md:w-[50%]"></div>
        <form className="xsm:w-[100%] md:w-[50%] mt-5">
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="email-input"
            >
              Email address
            </label>
            <input
              className="bg-[#F2F2F2] appearance-none rounded-md w-[59%] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="email-input"
              type="text"
              placeholder="Email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <div className="text-[12px] text-red-500">{emailError}</div>
          </div>
          <div className="mb-4 flex gap-[2%]">
            <div className="w-[60%]">
              <label
                className="block text-gray-700 font-bold mb-2"
                htmlFor="role-select"
              >
                Role permission <span className="text-red-600">*</span>
              </label>
              <Select
                value={role}
                className=" rounded-md"
                placeholder="Role permission"
                options={
                  adminStore.role === ROLE.ADMIN
                    ? optionsAdmin
                    : adminStore.role === ROLE.MANAGER
                    ? optionsManager
                    : undefined
                }
                theme={theme}
                styles={styles}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onChange={(e) => {
                  setRole(e);
                }}
              />
            </div>
            <div className="w-[40%] flex items-end">
              <div
                className="bg-[#EED484] text-[14px] py-2 px-3 w-[100%] rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2 justify-center"
                onClick={onSendClick}
                style={{
                  pointerEvents: `${isWaitingSend ? "none" : "unset"}`,
                }}
              >
                {isWaitingSend && <SpinnerCustom />}
                Add
              </div>
            </div>
          </div>
          <div className=" text-[12px] text-red-500 mt-[-17px]">
            {roleError}
          </div>
        </form>
        <div className="mt-10">
          <ManagerUserTable
            items={items}
            offset={offset}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            isFetching={isFetching}
            callApiGetUser={callApiGetUser}
            take={take}
            skip={skip}
          />
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Success modal"
          ariaHideApp={false}
        >
          <div className="flex-col text-center justify-center p-5">
            <div className="font-bold xsm:text-[16px] xs:text-[18px]">
              Successfully
            </div>
            <div className="flex justify-center mt-7">
              <Icon icon="mdi:success-circle" width={50} color="#00685e" />
            </div>
            <div className="flex justify-center mt-7">
              <div
                className="bg-[#EED484] text-[14px] py-2 px-3 w-[80%] rounded-2xl text-center hover:bg-[#dac176] cursor-pointer"
                onClick={closeModal}
              >
                Close
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default observer(UserManager);
